// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetAllOwnerCorporateDataListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllOwnerCorporateDataListQueryResult = { __typename?: 'Query', getAllOwnerCorporateData: Array<{ __typename?: 'OwnerCorporateDataDTO', city: string | null, corpName: string, defaultOwnerCorporateData: boolean, id: number, telephone: string | null, type: string | null, vatNumber: string | null, district: string | null }> };

export const GetAllOwnerCorporateDataListGql = gql`
    query GetAllOwnerCorporateDataList {
  getAllOwnerCorporateData {
    city
    corpName
    defaultOwnerCorporateData
    id
    telephone
    type
    vatNumber
    district
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllOwnerCorporateDataListInjectable extends Apollo.Query<GetAllOwnerCorporateDataListQueryResult, GetAllOwnerCorporateDataListQueryVariables> {
    override document = GetAllOwnerCorporateDataListGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */